import React, { Suspense } from "react";
import cn from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { FaWhatsapp } from "react-icons/fa";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import { Shipment } from "services/action";

import { Page } from "ui/components";
import CardContainerDetail from "ui/components/card/card.container.detail";

import { waFormat, formatPhone, formatDate } from "utilities/common";

const MapBox = React.lazy(() => import("ui/components/maps/route"));

const ShipmentScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();

  const StateLoading = useSelector(
    (state) => state?.Activity?.services["Shipment.Show"]
  );

  const [data, setData] = React.useState(null);

  const $onLoad = async (id) => {
    const req = await Dispatch(Shipment.$show(id));

    if (req?.message === "success") {
      setData(req?.data?.shipment);
    }
  };

  const ListHorizontal = ({ title, content, className }) => {
    const c = cn(
      className ? className : "",
      "row py-1 mb-1 list-item m-0 align-items-start fsz-12 border-bottom"
    );

    return (
      <div className={c}>
        <div className="col-4 p-0 fsz-12">{title}</div>
        <div className="col-1 p-0 fsz-12">:</div>
        <div className="col-7 p-0 text-start title fsz-12">{content}</div>
      </div>
    );
  };

  const ActionTransit = () => {
    return (
      <div className="col">
        <Button
          type="button"
          variant="primary"
          className="w-100 fs-7"
          onClick={() =>
            History.push(`/pod/${data?.id}/shipment`, {
              type: "console",
            })
          }
        >
          Transit
        </Button>
      </div>
    );
  };

  const ActionDispute = () => {
    return (
      <div className="col">
        <Button
          type="button"
          variant="danger"
          className="w-100 fs-7"
          onClick={() =>
            History.push(`/pod/${data?.id}/shipment`, {
              type: "disputed",
            })
          }
        >
          Gagal Kirim
        </Button>
      </div>
    );
  };

  const ActionDelivery = () => {
    return (
      <div className="col">
        <Button
          type="button"
          variant="success"
          className="w-100 fs-7"
          onClick={() =>
            History.push(`/pod/${data?.id}/shipment`, {
              type: "delivered",
            })
          }
        >
          Terkirim
        </Button>
      </div>
    );
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  if (StateLoading || !data) return null;

  return (
    <Page
      title={`Detail Shipment`}
      full
      action={
        <div className="row mb-2">
          <ActionTransit />
          <ActionDelivery />
          <ActionDispute />
        </div>
      }
    >
      <Suspense fallback={<div>Loading...</div>}>
        <MapBox destination={data?.destination} centerDynamic={false} />
      </Suspense>

      <div className="p-2 pb-5">
        <CardContainerDetail title="Detail">
          <ListHorizontal title="Kode" content={data?.code} />
          {data?.ref_code && (
            <ListHorizontal title="Kode Referensi" content={data?.ref_code} />
          )}
          {data?.tracking_code && (
            <ListHorizontal
              title="Kode Tracking"
              content={data?.tracking_code}
            />
          )}
          <ListHorizontal
            title="Tanggal"
            content={formatDate(data?.eta_at, "DD MMM YYYY")}
          />
          <ListHorizontal title="Shipper" content={data?.shipper?.name} />
        </CardContainerDetail>

        <CardContainerDetail title="Informasi Lokasi">
          <ListHorizontal
            title="Tujuan"
            content={
              <div>
                <div className="fw-bold fsz-12">{data?.destination?.name}</div>
                {data?.destination?.name === data?.location?.contact_person ? (
                  <div className="page-pretitle">
                    {waFormat(data?.destination?.phone_number)}
                  </div>
                ) : (
                  <div className="page-pretitle">
                    {data?.destination?.contact_person} -{" "}
                    {waFormat(data?.destination?.phone_number)}
                  </div>
                )}

                {formatPhone(data?.destination?.phone_number) ? (
                  <div
                    className="btn btn-block bg-success py-1 text-white fsz-12 border-0"
                    // style={{ backgroundColor: "#01E675" }}
                    onClick={() =>
                      window.open(
                        `https://wa.me/${waFormat(
                          data?.destination?.phone_number
                        )}`,
                        "_blank"
                      )
                    }
                  >
                    <FaWhatsapp size="15" color="#fff" className="me-1" />{" "}
                    Kontak
                  </div>
                ) : null}
              </div>
            }
          />
        </CardContainerDetail>

        {data?.items ? (
          <CardContainerDetail title="Detil Barang">
            <div className="py-2">
              <div className="table-responsive mb-0">
                <table
                  width="100%"
                  className="table table-hover table-vcenter card-table datatable border rounded"
                >
                  <thead className="bg-light">
                    <tr className="th">
                      <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                        Komoditas
                      </td>
                      <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                        Koli
                      </td>
                      <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                        Berat (Kg)
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.items?.map((d, i) => (
                      <tr key={i}>
                        <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                          {d?.item_name}
                        </td>
                        <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                          {d?.quantity}
                        </td>
                        <td style={{ whiteSpace: "nowrap", width: "15%" }}>
                          {d?.weight}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </CardContainerDetail>
        ) : null}
      </div>
    </Page>
  );
};

export default ShipmentScreen;
